import useRoutingInfo from "components/employees/hooks/useRoutingInfo"
import { useEffect } from "react"
import { getHeap } from "services/heap/heap-loader"
import useBenefits from "./useBenefits"

export function useTrackCarrotPlanCreation({ employeeId }: { employeeId: number }) {
  const { data: routingInfo, isLoading: isLoadingRoutingInfo, error: routingInfoLoadError } = useRoutingInfo(employeeId)
  const { data, isLoading: isLoadingMemberBenefit, error: memberBenefitLoadError } = useBenefits(employeeId)
  const memberBenefit = data?.items[0]
  const trackingEnabled = [
    isLoadingRoutingInfo,
    routingInfoLoadError,
    isLoadingMemberBenefit,
    memberBenefitLoadError
  ].every((condition) => !condition)

  useEffect(() => {
    if (trackingEnabled)
      getHeap().track("Carrot Plan creation started", {
        Journey: routingInfo?.journey,
        "Journey Stage": routingInfo?.journeyStage,
        "Program Type": memberBenefit.program?.type
      })
  }, [routingInfo?.journey, routingInfo?.journeyStage, trackingEnabled, memberBenefit])

  function trackCarrotPlanCreationComplete(args?: { recommendedItemsUsed?: number }) {
    if (trackingEnabled) {
      getHeap().track("Carrot Plan creation completed", {
        Journey: routingInfo?.journey,
        "Journey Stage": routingInfo?.journeyStage,
        "Program Type": memberBenefit.program?.type,
        "Number of recommended Carrot Plan items": args.recommendedItemsUsed || 0
      })
    }
  }
  return {
    trackCarrotPlanCreationComplete
  }
}
